import React from 'react';
import img1 from '../../../Assets/About/Mask-group.webp';

function useCountUp(end, duration = 1500) {
  const [value, setValue] = React.useState(0);
  const ref = React.useRef(null);
  const started = React.useRef(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          let start = 0;
          const increment = end / (duration / 16);

          const animate = () => {
            start += increment;
            if (start < end) {
              setValue(Math.floor(start));
              requestAnimationFrame(animate);
            } else {
              setValue(end);
            }
          };
          animate();
        }
      },
      { threshold: 0.6 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end, duration]);

  return { value, ref };
}


const WhoWeAre = () => {
    const startups = useCountUp(150);
const advisory = useCountUp(1);
const success = useCountUp(98);
const alliances = useCountUp(20);
  return (
    <section className="bg-gradient-to-br from-slate-50 via-slate-100 to-slate-50 py-10  px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Side - Image and Stats */}
          <div className="">
            {/* Main Image */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={img1}
                  alt="Business consulting team"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Decorative Elements */}
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-slate-200 rounded-2xl -z-10"></div>
            </div>

            {/* Stats Grid */}
            <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-8">
              <div className="grid md:grid-cols-2 gap-6 justify-center">
                {/* Stat 1 */}
                <div className="md:border-r border-b border-slate-200 pr-6 pb-6 flex items-center gap-2">
                 <div ref={startups.ref} className="flex items-center gap-1 mb-2">
                    <span className="text-3xl md:text-5xl font-bold text-slate-900">
                        {startups.value}
                    </span>
                    <span className="text-2xl font-bold text-slate-900">+</span>
                    </div>
                  <div>
                        <p className="text-slate-600 font-medium">Startups</p>
                        <p className="text-slate-600 font-medium">Supported</p>
                  </div>
                </div>

                {/* Stat 2 */}
                <div className="border-b border-slate-200 pb-6 flex items-center gap-2">
                  <div ref={advisory.ref} className="flex items-center gap-1 mb-2">
                    <span className="text-3xl md:text-5xl font-bold text-slate-900">
                        {advisory.value.toLocaleString()} M
                    </span>
                    <span className="text-2xl font-bold text-slate-900">+</span>
                </div>
                  <div>
                    <p className="text-slate-600 font-medium">Advisory</p>
                    <p className="text-slate-600 font-medium">Hours</p>
                  </div>
                </div>

                {/* Stat 3 */}
                <div className="border-b md:border-r border-slate-200 pr-6 py-6 flex items-center gap-2">
                  <div ref={success.ref} className="flex items-cenetr gap-1 mb-2">
                    <span className="text-3xl md:text-5xl font-bold text-slate-900">
                        {success.value}
                    </span>
                    <span className="text-2xl font-bold text-slate-900">%</span>
                    </div>
                  <div>
                  <p className="text-slate-600 font-medium">Success</p>
                  <p className="text-slate-600 font-medium">Rate</p>
                  </div>
                </div>

                {/* Stat 4 */}
                <div className="pt-6 flex items-center gap-2 ">
                  <div ref={alliances.ref} className="flex items-baseline gap-1 mb-2">
                    <span className="text-3xl md:text-5xl font-bold text-slate-900">
                        {alliances.value}
                    </span>
                    <span className="text-2xl font-bold text-slate-900">+</span>
                    </div>
                  <div>
                  <p className="text-slate-600 font-medium">Global</p>
                  <p className="text-slate-600 font-medium">Alliances</p>
                  </div>
                </div>

                {/* Decorative Star */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <svg className="w-6 h-6 text-slate-300" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-slate-300 rounded-full">
              <span className="text-slate-900 text-sm">✦</span>
              <span className="text-slate-900 font-medium">Who We Are</span>
            </div>

            {/* Heading */}
            <div className="">
              <h2 className='leading-relaxed' >
                <span className="text-3xl sm:text-4xl lg:text-5xl  font-bold text-slate-900 ">
                   Defining Excellence in
                </span>
               
                 <span className="text-3xl sm:text-4xl lg:text-5xl font-serif italic text-slate-900  ml-3">
                Business Consulting.
              </span>
              </h2>
             
            </div>

            {/* Description */}
            <p className="text-slate-600 text-lg leading-relaxed">
             We build tailored digital systems designed around real-world processes — not generic templates. From data-driven platforms to infrastructure and automation, our solutions are engineered to support scalability, precision, and operational efficiency.
            </p>

            {/* Features List */}
            <div className="space-y-5 pt-4">
              {/* Feature 1 */}
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-indigo-500 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-slate-900 text-lg font-medium pt-1">
                  Extensive Expertise and Global Experience
                </p>
              </div>

              {/* Feature 2 */}
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-indigo-500 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-slate-900 text-lg font-medium pt-1">
                  Client-Centric and Strategic Growth Approach
                </p>
              </div>

              {/* Feature 3 */}
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-indigo-500 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-slate-900 text-lg font-medium pt-1">
                  Commitment to Excellence and Lasting Quality
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;